const state = {
    customProducts:[],
};

const getters = {
    customProducts: state => state.customProducts,
};

const actions = {
    getCustomProducts({commit, state}){
        axios.get('/api/admin/custom/product').then((response) => {
            commit('setCustomProducts', response.data.data);
        })
    },
};

const mutations = {
    setCustomProducts(state, products){
        state.customProducts = products;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
